module.exports = __webpack_public_path__ + "static/media/mail-blue.103fcb1d.svg";